import styled from 'styled-components';

// Styled components matching device matrix theme
export const FormContainer = styled.div`
  border: 1px solid #4b286d;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
`;

export const TableContainer = styled.div`
  margin-bottom: 50px;
  position: relative;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
`;

export const Thead = styled.thead`
  background: #f2f2f2;
`;

export const Tr = styled.tr`
  border: 1px solid #e3e3e3;
`;

export const Td = styled.td`
  background: ${({ background }) => background || '#ffffff'};
  border: 1px solid #e3e3e3;
  padding: 16px;
  vertical-align: top;
`;

export const Th = styled.th`
  padding: 16px;
  background: #4b286d;
  color: #fff;
  font-weight: 600;
  text-align: left;
`;

export const ActionButton = styled.button`
  background: none;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 12px;
  color: #4b286d;
  margin: 2px;
  
  &:hover {
    background: #f7f7f7;
  }
`;

export const DeleteButton = styled(ActionButton)`
  color: #c12335;
  border-color: #f1d2d5;
  
  &:hover {
    background: #fff6f8;
  }
`;

export const SaveButton = styled.button`
  background: #2b8000;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  
  &:hover {
    background: #2a7300;
  }
`;

export const SelectedChip = styled.span`
  display: inline-block;
  background: #f5f5f5;
  color: #333;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin: 2px;
  border: 1px solid #ddd;
`;

export const FieldOptionsGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const FormFieldContainer = styled.div`
  margin-bottom: 1rem;
`;

export const BilingualFieldContainer = styled.div`
  margin-bottom: 1rem;
`;

export const ResponsiveTableContainer = styled.div`
  .responsive-table-container {
    overflow-x: auto;
  }

  .responsive-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;
  }

  .responsive-table__caption {
    font-weight: bold;
    text-align: left;
  }

  .responsive-table__thead {
    background: #f2f2f2;
  }

  .responsive-table__tbody tr {
    border-bottom: 1px solid #e3e3e3;
  }

  .responsive-table__tbody tr:hover {
    background: #f9f9f9;
  }

  .responsive-table__actions {
    text-align: center;
  }

  @media (max-width: 768px) {
    .responsive-table__thead {
      display: none;
    }

    .responsive-table__tbody tr {
      display: block;
      margin-bottom: 1rem;
      border: 1px solid #e3e3e3;
      border-radius: 4px;
    }

    .responsive-table__tbody td {
      display: block;
      text-align: right;
      padding: 0.5rem;
      border: none;
    }

    .responsive-table__tbody td:before {
      content: attr(data-header-label) ": ";
      float: left;
      font-weight: bold;
    }
  }
`;

// Modal styled components matching IoT order view popup
export const Backdrop = styled.div`
  overflow: scroll;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalMain = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 67%;
  max-width: 1200px;
  max-height: 80vh;
  z-index: 10000000;
  background-color: rgb(255, 255, 255);
  border-radius: 0.25rem;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 16px 0px;
  display: flex;
  flex-direction: column;
`;

export const ModalInner = styled.div`
  background-color: white;
  display: flex;
  flex-flow: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  overflow: scroll;
  position: relative;
`;

export const ModalMessageMain = styled.div`
  width: 100%;
  margin: 0 auto;
  border: 1px solid rgb(227, 227, 227);
  box-shadow: rgb(227 227 227) 1px 1px 9px 4px;
  overflow: scroll;
`;

export const ModalCancel = styled.div`
  float: right;
  padding: 8px 8px;
  position: absolute;
  right: 0%;
  top: 0%;
  z-index: 2;
`;

export const ModalHeading = styled.div`
  overflow-wrap: break-word;
  color: rgb(42, 44, 46);
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.4;
  letter-spacing: -0.6px;
  margin-bottom: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
`;

export const NavbarPopup = styled.div`
  background: rgb(75, 40, 109);
  padding: 10px;
`;

export const ModalHeadingStyled = styled.h2`
  font-size: 24px;
  font-weight: 500;
  color: #fff;
`;

export const ModalButton = styled.div`
  border: none;
  cursor: pointer;
  margin-right: 7px;
  background: none;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
`;



// Pagination styles matching other components
export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
  margin-top: 1rem;
`;

export const PaginationContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 25px;
  box-shadow: 1px 1px 5px 0 #d5d5d5;
  height: 48px;
  margin: 8px 0 28px !important;
  padding: 1rem;
`;

export const PageButtons = styled.button`
  background-color: #fff !important;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    border-color: #4b286d;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const ActivePage = styled.button`
  background-color: #4b286d !important;
  color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: pointer;
  font-weight: 500;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const NaviagationButtons = styled.button`
  background-color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    border-color: #4b286d;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const NaviagationButtonText = styled.p`
  font-size: 24px;
  margin-top: -7px;
`;

// Button styles matching formButtons pattern
export const PrimaryButton = styled.button`
  &.frg-button.color-green {
    background-color: #2b8000;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    
    &:hover:not(:disabled) {
      background-color: #2a7300;
    }
    
    &:disabled {
      background-color: #cccccc;
      color: #666666;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`;

export const SecondaryButton = styled.button`
  &.frg-button.color-purple {
    background-color: #4b286d;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    
    &:hover:not(:disabled) {
      background-color: #3d1f57;
    }
    
    &:disabled {
      background-color: #cccccc;
      color: #666666;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`;